import {COMPLETED, DOWNLOADING, INIT, PROCESSING, UPLOADING} from "../../../pages/detection/detection_page";

export function init() {
    return {
        type: INIT,
    }
}

export function uploading(file, src) {
    return {
        type: UPLOADING,
        payload: {file, src}
    }
}

export function processing() {
    return {
        type: PROCESSING
    }
}

export function downloading(result) {
    return {
        type: DOWNLOADING,
        payload: result
    }
}

export function completed(src) {
    return {
        type: COMPLETED,
        payload: src
    }
}